import {
    IStaffDashboardStatistics, IStaffDashboardStatisticsByCountries, IStaffDashboardStatisticsByStaff, IUsersImportList,
} from '@/interfaces/staff';
import { StaffState } from './state';
import { getStoreAccessors } from 'typesafe-vuex';
import { State } from '../state';


export const mutations = {
    setStaffDashboardStatistics(state: StaffState, payload: IStaffDashboardStatistics) {
        state.staffDashboardStatistics = payload;
    },
    setStaffDashboardStatisticsByCountries(state: StaffState, payload: IStaffDashboardStatisticsByCountries[]) {
        state.staffDashboardStatisticsByCountries = payload;
    },
    setStaffDashboardStatisticsByStaff(state: StaffState, payload: IStaffDashboardStatisticsByStaff[]) {
        state.staffDashboardStatisticsByStaff = payload;
    },
    setUsersImportsList(state: StaffState, payload: IUsersImportList[]) {
        state.usersImportsList = payload;
    },
};

const {commit} = getStoreAccessors<StaffState | any, State>('');

export const commitSetStaffDashboardStatistics = commit(mutations.setStaffDashboardStatistics);
export const commitSetStaffDashboardStatisticsByCountries = commit(mutations.setStaffDashboardStatisticsByCountries);
export const commitSetStaffDashboardStatisticsByStaff = commit(mutations.setStaffDashboardStatisticsByStaff);
export const commitSetUsersImportsList = commit(mutations.setUsersImportsList);
